import { Icon } from '@chakra-ui/react';

export default function SFBoltFillIcon(props) {
  return (
    <Icon
      width={3}
      height={19}
      viewBox='0 0 12 19'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M0.492188 10.2657C0.492188 10.0939 0.5625 9.93762 0.695312 9.76574L7.79688 0.898557C8.32031 0.234494 9.15625 0.664182 8.85156 1.46887L6.52344 7.79699H10.9375C11.2656 7.79699 11.5 8.03137 11.5 8.32824C11.5 8.50793 11.4297 8.66418 11.2969 8.82824L4.19531 17.7032C3.67188 18.3595 2.83594 17.9298 3.14062 17.1251L5.46875 10.797H1.05469C0.726562 10.797 0.492188 10.5704 0.492188 10.2657Z' />
    </Icon>
  );
}
